/*
  ONECART：IP からのマーケット提案（2026-09-14）。snippets/oc-market-suggest.liquid とセット。
  提案だけ行い、ブロック・自動リダイレクトはしない。
*/
(function () {
  var root = document.getElementById('oc-market-suggest');
  var dataEl = document.getElementById('oc-market-suggest-data');
  if (!root || !dataEl) return;

  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var KEY = 'oc_market_suggest_dismissed';
  var current = data.current;

  // カートに商品があるときだけ、今の国を配送先として記録する（Phase 6 のカート検証用）
  if (data.cartItemCount > 0 && data.cartShipCountry !== current) {
    fetch(data.cartUpdateUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { __ship_country: current } }),
    }).catch(function () {});
  }

  function dismissedList() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function remember(code) {
    try {
      var list = dismissedList();
      if (list.indexOf(code) === -1) list.push(code);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function fill(template, vars) {
    return String(template).replace(/\[(\w+)\]/g, function (match, key) {
      return vars[key] != null ? vars[key] : match;
    });
  }

  // Shopify の Cookie 同意バナー（#shopify-pc__banner・画面下固定・z-index 2000000）と
  // 同じ位置に重なるので、それが出ている間は待つ（2026-09-14 プレビューで重なりを確認）
  function consentBannerVisible() {
    var el = document.getElementById('shopify-pc__banner');
    if (!el) return false;
    var style = getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && el.getBoundingClientRect().height > 0;
  }

  // 同意バナーは後から差し込まれることがあるので、2回続けて出ていないのを見てから呼ぶ
  function whenConsentBannerClosed(callback) {
    var clearChecks = 0;
    var started = Date.now();
    (function tick() {
      if (consentBannerVisible()) {
        clearChecks = 0;
      } else if (++clearChecks >= 2) {
        callback();
        return;
      }
      if (Date.now() - started > 10 * 60 * 1000) return; // 10分閉じられなければ出さない
      setTimeout(tick, 1500);
    })();
  }

  fetch(data.suggestUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
    .then(function (res) {
      return res.ok ? res.json() : null;
    })
    .then(function (res) {
      var detected = res && res.detected_values && res.detected_values.country;
      var code = detected && detected.handle;
      if (!code || code === current || dismissedList().indexOf(code) !== -1) return;

      var target = data.countries[code]; // この店で選べる国（マーケットあり）
      var sister = data.sister[code]; // 姉妹店がある国
      if (!target && !sister) return; // JP・未対応の国では何も出さない

      var vars = {
        country: target ? target.name : detected.name || code,
        currency: target ? target.currency : '',
        store: sister ? sister.name : '',
      };
      var text = root.querySelector('.oc-market-suggest__text');
      var switchBtn = root.querySelector('[data-role="switch"]');
      var sisterLink = root.querySelector('[data-role="sister"]');
      var stayBtn = root.querySelector('[data-role="stay"]');
      var closeBtn = root.querySelector('[data-role="close"]');

      text.textContent = fill(target ? data.strings.switchText : data.strings.sisterText, vars);
      stayBtn.textContent = data.strings.stayButton;

      if (target) {
        switchBtn.textContent = fill(data.strings.switchButton, vars);
        switchBtn.form.querySelector('input[name="country_code"]').value = code;
        switchBtn.hidden = false;
        switchBtn.form.addEventListener('submit', function () {
          remember(code);
        });
      }
      if (sister) {
        sisterLink.textContent = fill(data.strings.sisterLink, vars);
        sisterLink.href = sister.url;
        // 切替ボタンと並ぶとき（HK）は、姉妹店を控えめなリンクにする
        if (target) {
          sisterLink.classList.remove('oc-market-suggest__btn--primary');
          sisterLink.classList.add('oc-market-suggest__btn--link');
        }
        sisterLink.hidden = false;
        sisterLink.addEventListener('click', function () {
          remember(code);
        });
      }

      function close() {
        remember(code);
        root.hidden = true;
      }
      stayBtn.addEventListener('click', close);
      closeBtn.addEventListener('click', close);
      whenConsentBannerClosed(function () {
        root.hidden = false;
      });
    })
    .catch(function () {});
})();
